import { useState } from "react";

interface ExpandableNoteProps {
  text: string;
  /** Characters shown before the note is collapsed behind "View more". */
  previewLength?: number;
  /** What the note belongs to, for the toggle's accessible name. */
  label: string;
  children?: never;
}

const DEFAULT_PREVIEW_LENGTH = 250;

/** Inline note text: short notes show whole; long ones show a preview with a View more / View less toggle for that row only. */
export function ExpandableNote({ text, previewLength = DEFAULT_PREVIEW_LENGTH, label }: ExpandableNoteProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const needsToggle = text.length > previewLength;
  const shown = !needsToggle || isExpanded ? text : `${text.slice(0, previewLength).trimEnd()}…`;

  return (
    <span className="block max-w-md whitespace-pre-wrap text-gray-700">
      {shown}
      {needsToggle && (
        <>
          {" "}
          <button type="button" className="cursor-pointer text-xs font-medium text-brand-navy underline-offset-2 hover:underline focus:outline-none focus:ring-2 focus:ring-brand-green-50 rounded" aria-expanded={isExpanded} aria-label={`${isExpanded ? "View less" : "View more"} of ${label}`} onClick={() => setIsExpanded((current) => !current)}>
            {isExpanded ? "View less" : "View more"}
          </button>
        </>
      )}
    </span>
  );
}
